import { render, staticRenderFns } from "./LevelStatusBadge.vue?vue&type=template&id=8b36f6fc&scoped=true"
import script from "./LevelStatusBadge.vue?vue&type=script&lang=js"
export * from "./LevelStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./LevelStatusBadge.vue?vue&type=style&index=0&id=8b36f6fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b36f6fc",
  null
  
)

export default component.exports